<template lang="pug">
  .container-outlay
    router-view
</template>

<script>
export default {
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
  },
  mounted () {
    if (!this.outlay_account_id) {
      this.$alert('无效的营销账户 ID', {
        type:     'error',
      }).then(() => {
        this.$router.push('/outlay');
      });
    }
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-outlay {
  .point-outer-container {
    .flex(center, flex-start);
  }
  .point-container {
    .flex(center, center, column);
    .align-center;
    min-width:  150px;

    &:first-child {
      border-right:   1px solid @grey;
    }
  }
  .point-title {
    padding:  10px 0;
  }
  .point-title-hint {
    .flex(center, center);
  }
  .point-amount {
    .bold;
    font-size:  24px;
  }

  .point-rule {
    .flex(center, space-between);
    margin-bottom:  10px;

    .point-hint {
      .circle(24px);
      .bold;
      border-width: 2px;
      border-color: @background-blue-active;
      color:        @background-blue-active;
    }
  }
  .point-hint {
    .border-box;
    .flex(center, center);
    .circle(20px);
    .bold;
    .cursor-pointer;
    font-size:      12px;
    border:         1px solid @grey;
    color:          @grey;
    margin-left:    8px;
  }
  .point-date {
    .bold;
  }

  .outlay-chart-container {
    height:         400px;

    .outlay-chart {
      .margin-center;
    }
  }
}
</style>
